import baseGet from './_baseGet.js';
import baseSlice from './_baseSlice.js';

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

export default parent;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/_parent.js
// module id = 699
// module chunks = 0